<div class="picker-box">

    <ng-container *ngIf="isLarge$ | async; else contentForModal">
      Showing tests for:
      <app-persona-picker-popover></app-persona-picker-popover>
    </ng-container>
    <ng-template #contentForModal>
      <app-persona-picker-modal></app-persona-picker-modal>
    </ng-template>

</div>
